// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.p-button[data-v-3903a657] {\n  text-decoration: none;\n}", "",{"version":3,"sources":["webpack://./resources/js/Components/LinkButton.vue"],"names":[],"mappings":"AAEA;EACE,qBAAA;AADF","sourcesContent":["\n@import '../../scss/_variables';\na.p-button {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
